import { KeyboardEventHandler } from 'react';

const ENTER = 'Enter';
const ESCAPE = 'Escape';

export const getOnKeyDownForInput = (
  onMultiSelectUpdate: () => void,
  isMenuOpen: boolean,
): KeyboardEventHandler<HTMLInputElement> => {
  return (event) => {
    if (event.key === ENTER || event.key === ESCAPE) {
      event.preventDefault();
      if (
        ('value' in event.target && event.target.value === '' && !isMenuOpen) ||
        event.key === ESCAPE
      ) {
        onMultiSelectUpdate();
      }
    }
  };
};
